import React from 'react'
import Column from '~/Common-Objects/Grids/Column/Column'
import LoadingIconFull from '~/Common-Objects/LoadingIcons/loadingIconFull'
import Row from '~/Common-Objects/Grids/Row/Row'
import SmallLineGraph from '~/Common-Objects/UI/Graphs/SmallLineGraph/SmallLineGraph'
import axios from '~/data/http/axios'
import { connect } from 'react-redux'
import i18n from '~/i18n'
import PermissionChecker from '~/Classes/permissions'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import axios2 from 'axios'

//wizards stuff
import IncGoAddGroup from '../subscribers/groups/incGoAddGroup.jsx'
import DrawerAddCampaignStep1 from '~/pages/cp/campaigns/add/drawerAddCampaignStep1'
import FormGroupSelect from '~/pages/cp/forms/GroupSelect'
import Capsule from './capsule'
import AppHooks from '../company/integrations/apps/genericCp/hooks2'

import SubscribersOpened from './components/subscribersOpened'
import NewSubscribers from './components/newSubscribers'
import YourPlan from './components/yourPlan'

import CampaignChart from './components/campaignChart'
import CampaignTable from './components/campaignTable'

import QuickTips from './components/quickTips'
import WhatsNew from './components/whatsNew'
import LatestNews from './latestNews'

import AutomationPanel from './components/automationPanel'
import SiteVisitsPanel from './components/sitevisitsPanel'

import ChangePanel from './components/changePanel'
import ChangeChart from './components/changeChart'
import ChangeTable from './components/changeTable'

import FormChart from './components/formChart.jsx'
import AutomationChart from './components/automationChart'
import SiteVisitTable from './components/sitevisitTable.jsx'
import AutomationTable from './components/automationTable.jsx'
import FormTable from './components/formTable.jsx'
import SubscribersClicked from './components/subscribersClicked.jsx'
import GettingStarted from './gettingStarted.jsx'
import { getUserSettings, setUserSettings } from '../../../Classes/userSettings.jsx'
import CreateAutomationModal from '../includes/automations/createAutomationModal/index.jsx'
import AccountSuggestions from './components/suggestions.jsx'

@connect((store) => {
    return {
        siteMaster: store.siteMaster,
        browser: store.browser,
        user: store.user,
        accountMaster: store.accountMaster,
        permissionStore: store.permission
    }
})
export default class ControlTemplate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loaded: false,
            transactions: {
                current: 0,
                last: 0,
                increase: 0,
                decrease: 0
            },
            campaigns: [],
            opens: {
                current: 0,
                last: 0,
                increase: 0,
                decrease: 0
            },
            clicks: {
                current: 0,
                last: 0,
                increase: 0,
                decrease: 0
            },
            subscribers: {
                current: 0,
                last: 0,
                increase: 0,
                decrease: 0
            },
            groupCount: 0,
            apps: null,
            customFields: [],
            settings: null
        }

        this.CancelToken = axios2.CancelToken
        this.source = this.CancelToken.source()

        this.getCampaigns = this.getCampaigns.bind(this)
        this.getStats = this.getStats.bind(this)
        // this.checkTransaction = this.checkTransaction.bind(this)
        // this.getTransaction = this.getTransaction.bind(this)
        this.getGroupCount = this.getGroupCount.bind(this)
        this.addCampaign = this.addCampaign.bind(this)

        //wizard stuff
        this.addGroup = this.addGroup.bind(this)
        this.addForm = this.addForm.bind(this)
        this.addAutomation = this.addAutomation.bind(this)
        this.addAutomationBack = this.addAutomationBack.bind(this)

        this.viewAppActions = this.viewAppActions.bind(this)
        this.changePanel = this.changePanel.bind(this)
    }

    componentDidMount() {
        // this.transactionTimer = setInterval(this.getTransaction, 1000 * 10)
        axios.get('/accountMaster/application').then((res) => {
            this.setState({ apps: res.data.Applications })
            this.getStats()
        })
        axios.get('/customfield').then((res) => {
            this.setState({ customFields: res.data.CustomFields })
        })
        getUserSettings().then((s) => {
            let save = false
            if (!s.frontpage) s.frontpage = {}
            if (!s.frontpage.panels && this.props.accountMaster.panels) {
                save = true
                s.frontpage.panels = this.props.accountMaster.panels
            }
            if (!s.frontpage.chart && this.props.accountMaster.chart) {
                save = true
                s.frontpage.chart = this.props.accountMaster.chart
            }
            if (!s.frontpage.table && this.props.accountMaster.table) {
                save = true
                s.frontpage.table = this.props.accountMaster.table
            }
            this.setState({ settings: s }, () => {
                if (save) this.saveSettings()
            })
        })
    }

    componentWillUnmount() {
        this.source.cancel('I cancelled this')
        this.source = this.CancelToken.source()
        if (this.transactionTimer) {
            clearInterval(this.transactionTimer)
        }
    }

    saveSettings() {
        setUserSettings(this.state.settings).catch(console.log)
    }

    getStats() {
        if (this.props.permissionStore.permissions.campaigns === 'none') return this.getGroupCount()
        axios
            .get('/campaign/overview', {
                cancelToken: this.source.token
            })
            .then((response) => {
                var opens = response.data.Opens
                var clicks = response.data.Clicks
                var subscribers = response.data.Subscribers
                opens.increase = 0
                opens.decrease = 0
                if (opens.current > opens.last) {
                    opens.increase = Math.round((opens.current / opens.last) * 100) - 100
                } else {
                    opens.decrease = 100 - Math.round((100 / opens.last) * opens.current)
                }

                clicks.increase = 0
                clicks.decrease = 0
                if (clicks.current > clicks.last) {
                    clicks.increase = Math.round((clicks.current / clicks.last) * 100) - 100
                } else {
                    clicks.decrease = 100 - Math.round((100 / clicks.last) * clicks.current)
                }

                subscribers.increase = 0
                subscribers.decrease = 0
                if (subscribers.current > subscribers.last) {
                    subscribers.increase = Math.round((subscribers.current / subscribers.last) * 100) - 100
                } else {
                    subscribers.decrease = 100 - Math.round((100 / subscribers.last) * subscribers.current)
                }

                this.setState(
                    {
                        clicks,
                        opens,
                        subscribers
                    },
                    this.getCampaigns
                )
            })
            .catch(() => {})
    }

    getCampaigns() {
        axios
            .get(
                '/campaign?sortColumn=startDate&sortOrder=desc&startRecord=0&recordLimit=5&dontCount=true&status=2&status=3&status=4&status=5&status=6&status=7&status=8&status=9]&includeArchived=true',
                {
                    cancelToken: this.source.token
                }
            )
            .then((response) => {
                this.setState(
                    {
                        campaigns: response.data.Campaigns.map((row, index) => {
                            return {
                                campaignName: {
                                    headerValue: i18n.t('campaigns:main.campaignName'),
                                    value: (
                                        <a
                                            onClick={() => this.props.history.push('/cp/campaigns/view/' + row.id)}
                                            style={{ fontWeight: 600 }}
                                        >
                                            {row.campaignName}
                                        </a>
                                    ),
                                    orderBy: false
                                },
                                statsOpened: {
                                    headerValue: i18n.t('campaigns:main.statsOpened'),
                                    value: (
                                        <SmallLineGraph
                                            color='#7246B1'
                                            width='100'
                                            height='5'
                                            val1={row.stats['Unique Opens'] || 0}
                                            val2={row.stats['Total Subscribers'] || 0}
                                        />
                                    ),
                                    orderBy: false
                                },
                                statsClicked: {
                                    headerValue: i18n.t('campaigns:main.statsClicked'),
                                    value: (
                                        <SmallLineGraph
                                            color='#65B5B1'
                                            width='100'
                                            height='5'
                                            val1={row.stats['Unique Clicks'] || 0}
                                            val2={row.stats['Total Subscribers'] || 0}
                                        />
                                    ),
                                    orderBy: false
                                },
                                statsBounces: {
                                    headerValue: i18n.t('campaigns:main.statsBounced'),
                                    value: (
                                        <SmallLineGraph
                                            color='#CC4E32'
                                            width='100'
                                            height='5'
                                            val1={row.stats['Hard Bounces'] || 0}
                                            val2={row.stats['Total Subscribers'] || 0}
                                        />
                                    ),
                                    orderBy: false
                                }
                            }
                        })
                    },
                    this.getGroupCount
                )
            })
            .catch(() => {})
    }

    addCampaign() {
        var drawerContent = <DrawerAddCampaignStep1 history={this.props.history} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, false, 'left', drawerContent, true, 500, 'drawer_nopad'))
    }
    getGroupCount() {
        if (this.props.permissionStore.permissions.subscribers === 'none') return this.setState({ loaded: true })
        axios
            .get('/group/count', {
                cancelToken: this.source.token
            })
            .then((response) => {
                this.setState({ groupCount: response.data.Count, loaded: true })
            })
            .catch(() => {})
    }

    //Wizard stuff

    addGroup() {
        var drawerContent = (
            <IncGoAddGroup
                addedGroup={(newGroup) => {
                    this.props.history.push(`/cp/groups/${newGroup.data.groupId}/add/import`)
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '500px'))
    }

    addForm() {
        var drawerContent = <FormGroupSelect history={this.props.history} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '500px'))
    }
    addAutomation() {
        var drawerContent = (
            <AutomationThemeSelector
                scratch={() => {
                    this.props.history.push('/cp/automation/addnew')
                }}
                select={this.addAutomationBack}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '100vw', 'full'))
    }
    addAutomationBack(theme) {
        axios.post('/automation/theme/' + theme.id).then((response) => {
            this.props.history.push('/cp/automation/addnew/' + response.data.Automation.id)
        })
    }

    viewAppActions(app) {
        const accApp = app.AccountApplications[0]
        var drawerContent = (
            <AppHooks
                appSettings={accApp.appSettings}
                app={app}
                appBinding={accApp}
                customFields={this.state.customFields}
                onChange={() => {}}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '100vw', 'full'))
    }
    runSiteAnalyzer() {
        this.props.history.push('/cp/brandanalyzer')
    }
    changePanel(index) {
        var drawerContent = (
            <ChangePanel
                current={this.state.settings.frontpage?.panels}
                index={index}
                onSave={(panels) => {
                    const settings = this.state.settings
                    if (!settings.frontpage) settings.frontpage = {}
                    settings.frontpage.panels = panels
                    this.setState({ settings }, this.saveSettings)
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, 400))
    }

    changeChart() {
        var drawerContent = (
            <ChangeChart
                current={this.state.settings.frontpage?.chart}
                onSave={(chart) => {
                    const settings = this.state.settings
                    if (!settings.frontpage) settings.frontpage = {}
                    settings.frontpage.chart = chart
                    this.setState({ settings }, this.saveSettings)
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, 400))
    }

    changeTable() {
        var drawerContent = (
            <ChangeTable
                current={this.state.settings.frontpage?.table}
                onSave={(table) => {
                    const settings = this.state.settings
                    if (!settings.frontpage) settings.frontpage = {}
                    settings.frontpage.table = table
                    this.setState({ settings }, this.saveSettings)
                }}
            />
        )
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, 400))
    }

    render() {
        if (!this.state.loaded || !this.state.apps || !this.state.settings)
            return (
                <div className='loadingIconFullHost'>
                    <LoadingIconFull />
                </div>
            )

        var openProgress = 100
        if (this.state.opens.decrease) {
            openProgress = (100 / this.state.opens.last) * this.state.opens.current
        }

        var subProgress = 100
        if (this.state.subscribers.decrease) {
            subProgress = (100 / this.state.subscribers.last) * this.state.subscribers.current
        }

        var hasGroups = this.state.groupCount > 0
        var hasCampaigns = this.state.campaigns.length > 0
        // var hasCampaigns = false;

        let canSeeCampaignStats = true
        if (!PermissionChecker('campaigns', this.props.permissionStore.permissions, 'read')) canSeeCampaignStats = false
        const canCreateCampaigns = PermissionChecker('campaigns', this.props.permissionStore.permissions, 'write')
        const canSeeGroups = PermissionChecker('subscribers', this.props.permissionStore.permissions, 'read')

        var isAdmin = true
        if (this.props.user.userData.roleId != 1) {
            hasGroups = true
            hasCampaigns = true
            isAdmin = false
        }

        let hasDoneSiteAnalysis = false
        if (this.props.accountMaster.accountMaster.twitterAddress) {
            hasDoneSiteAnalysis = true
        }
        const capsule = this.state.apps.find((a) => a.ApplicationId === 8)

        const panels = this.state.settings.frontpage?.panels || ['opens', 'newcontacts', 'billing']
        const chart = this.state.settings.frontpage?.chart || 'campaigns'
        const table = this.state.settings.frontpage?.table || 'campaigns'

        let showBillingBox = false
        if (this.props.accountMaster.accountMaster.billedOnContacts) showBillingBox = true
        if (this.props.siteMaster.siteId == '1') showBillingBox = true

        return (
            <div className='frontpage'>
                <Row>
                    <Column xs={12} sm={12} md={showBillingBox ? 4 : 6} lg={showBillingBox ? 4 : 6} margin={0}>
                        {panels[0] === 'opens' && (
                            <SubscribersOpened opens={this.state.opens} edit={() => this.changePanel(0)} />
                        )}
                        {panels[0] === 'clicks' && (
                            <SubscribersClicked clicks={this.state.clicks} edit={() => this.changePanel(0)} />
                        )}
                        {panels[0] === 'newcontacts' && (
                            <NewSubscribers subscribers={this.state.subscribers} edit={() => this.changePanel(0)} />
                        )}
                        {panels[0] === 'automations' && <AutomationPanel edit={() => this.changePanel(0)} />}
                        {panels[0] === 'sitevisits' && <SiteVisitsPanel edit={() => this.changePanel(0)} />}
                    </Column>

                    <Column xs={12} sm={12} md={showBillingBox ? 4 : 6} lg={showBillingBox ? 4 : 6} margin={0}>
                        {panels[1] === 'opens' && (
                            <SubscribersOpened opens={this.state.opens} edit={() => this.changePanel(1)} />
                        )}
                        {panels[1] === 'clicks' && (
                            <SubscribersClicked clicks={this.state.clicks} edit={() => this.changePanel(1)} />
                        )}
                        {panels[1] === 'newcontacts' && (
                            <NewSubscribers subscribers={this.state.subscribers} edit={() => this.changePanel(1)} />
                        )}
                        {panels[1] === 'automations' && <AutomationPanel edit={() => this.changePanel(1)} />}
                        {panels[1] === 'sitevisits' && <SiteVisitsPanel edit={() => this.changePanel(1)} />}
                    </Column>

                    {showBillingBox && (
                        <Column xs={12} sm={12} md={4} lg={4} margin={0}>
                            <YourPlan history={this.props.history} />
                        </Column>
                    )}
                </Row>

                {/* {this.props.siteMaster.siteId == "1" && <LatestNews />} */}

                {canSeeCampaignStats && (
                    <Row className='frontpage-chart-row'>
                        <Column
                            xs={12}
                            sm={12}
                            md={12}
                            lg={this.props.siteMaster.siteId == '1' ? 8 : 12}
                            margin='0'
                            className='hide-xs'
                        >
                            {chart === 'campaigns' && <CampaignChart edit={this.changeChart.bind(this)} />}
                            {chart === 'forms' && <FormChart edit={this.changeChart.bind(this)} />}
                            {chart === 'automations' && <AutomationChart edit={this.changeChart.bind(this)} />}
                        </Column>
                        {this.props.siteMaster.siteId == '1' && (
                            <Column xs={12} sm={12} md={12} lg={4} margin={0}>
                                <WhatsNew />
                            </Column>
                        )}
                    </Row>
                )}

                {canSeeCampaignStats && (
                    <Row>
                        <Column xs={12} sm={12} md={12} margin='0'>
                            {table === 'campaigns' && (
                                <CampaignTable
                                    addCampaign={this.addCampaign}
                                    campaigns={this.state.campaigns}
                                    canCreateCampaigns={canCreateCampaigns}
                                    history={this.props.history}
                                    edit={this.changeTable.bind(this)}
                                />
                            )}
                            {table === 'automations' && <AutomationTable edit={this.changeTable.bind(this)} />}
                            {table === 'forms' && <FormTable edit={this.changeTable.bind(this)} />}
                            {table === 'sitevisits' && <SiteVisitTable edit={this.changeTable.bind(this)} />}
                        </Column>
                    </Row>
                )}
            </div>
        )
    }
}
